/* Signature — product page: variant resolution, gallery, AJAX add-to-cart.
   The native form works without JS; this layer improves it. */
(function () {
  'use strict';

  const root = document.getElementById('product-root');
  if (!root) return;

  /* The sticky-header offset (--vf-header-h) is measured sitewide in
     header.js; product.css uses it to pin the gallery below the header. */

  const addBtn = root.querySelector('[data-add-button]');
  let variantController = null;
  if (window.SignatureVariantState) {
    variantController = window.SignatureVariantState.bind(root, {
      updateHistory: true,
      structuredData: root.querySelector('[data-product-jsonld]'),
    });
  }

  /* ---------- Gallery ---------- */
  function revealActiveThumb() {
    const active = root.querySelector('.product__thumb.is-active');
    if (active && typeof active.scrollIntoView === 'function') {
      try {
        active.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
      } catch (error) {
        /* Older engines without options support can skip the reveal. */
      }
    }
  }

  root.querySelectorAll('.product__thumb').forEach((thumb) => {
    thumb.addEventListener('click', () => {
      const id = thumb.getAttribute('data-media-id');
      if (window.SignatureVariantState) {
        window.SignatureVariantState.activateMedia(root, id);
        revealActiveThumb();
      }
    });
  });

  /* Swipe the main image on touch screens — native-gallery feel without
     restructuring the template-swap mechanism. */
  const mainMedia = root.querySelector('[data-main-media]');
  if (mainMedia && window.SignatureVariantState) {
    const mediaIds = () =>
      Array.from(root.querySelectorAll('.product__thumb')).map((thumb) =>
        thumb.getAttribute('data-media-id'));
    const stepMedia = (direction) => {
      const ids = mediaIds();
      if (ids.length < 2) return;
      const current = mainMedia.getAttribute('data-current-media-id');
      let index = ids.indexOf(current);
      index = (index + direction + ids.length) % ids.length;
      window.SignatureVariantState.activateMedia(root, ids[index]);
      revealActiveThumb();
    };
    let touchStartX = null;
    let touchStartY = null;
    mainMedia.addEventListener('touchstart', (event) => {
      touchStartX = event.touches[0].clientX;
      touchStartY = event.touches[0].clientY;
    }, { passive: true });
    mainMedia.addEventListener('touchend', (event) => {
      if (touchStartX === null) return;
      const dx = event.changedTouches[0].clientX - touchStartX;
      const dy = event.changedTouches[0].clientY - touchStartY;
      touchStartX = null;
      touchStartY = null;
      /* Horizontal intent only — vertical scrolling must stay untouched. */
      if (Math.abs(dx) < 48 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
      stepMedia(dx < 0 ? 1 : -1);
    }, { passive: true });
  }

  /* ---------- Fixed purchase bar ----------
     Shown once the real buy row has scrolled up out of view. Measured on
     scroll (rAF-throttled) and re-queried each time, so it keeps working
     even if the buy row is re-rendered or sits inside the sticky panel. */
  const stickyBar = root.querySelector('[data-sticky-atc]');
  if (stickyBar && root.querySelector('.product__buy')) {
    let ticking = false;
    const checkSticky = () => {
      ticking = false;
      const row = root.querySelector('.product__buy');
      if (!row) return;
      const passed = row.getBoundingClientRect().bottom < 0;
      if (stickyBar.hidden === passed) stickyBar.hidden = !passed;
    };
    const queueSticky = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(checkSticky);
    };
    window.addEventListener('scroll', queueSticky, { passive: true });
    window.addEventListener('resize', queueSticky);
    checkSticky();
  }

  /* ---------- Savings label ----------
     Shows the real dollar saving plus the percentage: "Save $64 (19%)".
     The percentage rounds DOWN so it is never bigger than the real saving,
     matching the server-rendered (floored) value in price.liquid. */
  const savingsEl = root.querySelector('[data-savings]');
  if (savingsEl) {
    const amount = (el) => (el ? parseFloat(el.textContent.replace(/[^0-9.]/g, '')) : NaN);
    const fixSavings = () => {
      if (savingsEl.hidden) return;
      const cur = amount(root.querySelector('[data-price-wrap] [data-current-price]') || root.querySelector('[data-current-price]'));
      const cmp = amount(root.querySelector('[data-compare-price]'));
      if (!(cur > 0) || !(cmp > cur)) return;
      const pct = Math.floor(((cmp - cur) / cmp) * 100 + 0.000001);
      const cents = Math.round((cmp - cur) * 100);
      const dollars = (cents / 100).toLocaleString('en-US', {
        minimumFractionDigits: cents % 100 ? 2 : 0,
        maximumFractionDigits: 2,
      });
      const text = 'Save $' + dollars + (pct > 0 ? ' (' + pct + '%)' : '');
      if (cents > 0 && savingsEl.textContent !== text) savingsEl.textContent = text;
    };
    fixSavings();
    if ('MutationObserver' in window) {
      new MutationObserver(fixSavings).observe(savingsEl, {
        attributes: true, childList: true, subtree: true, characterData: true,
      });
    }
  }

  /* ---------- Sticky bar content (ShipIt-style) ----------
     The server renders a price span + button. Enrich it with the product
     thumbnail and title, and put the live price inside the button:
     "Add to cart · $X", plus the struck-through compare-at price only when a
     genuine one is shown on the page. Prices stay live — variant-state.js
     updates every [data-current-price] in the root, and the compare-at is
     mirrored from the main price block whenever it changes. */
  if (stickyBar) {
    const stickyBtn = stickyBar.querySelector('[data-sticky-add]');
    const titleEl = root.querySelector('.product__title');
    const thumbImg = root.querySelector('.product__thumb img') || root.querySelector('[data-main-media] img');
    if (thumbImg && !stickyBar.querySelector('.product__sticky-thumb')) {
      const thumb = document.createElement('span');
      thumb.className = 'product__sticky-thumb';
      const img = document.createElement('img');
      img.src = thumbImg.currentSrc || thumbImg.src;
      img.alt = '';
      img.width = 48;
      img.height = 48;
      img.loading = 'lazy';
      thumb.appendChild(img);
      stickyBar.prepend(thumb);
    }
    if (titleEl && !stickyBar.querySelector('.product__sticky-title')) {
      const title = document.createElement('span');
      title.className = 'product__sticky-title';
      title.textContent = titleEl.textContent.trim();
      const thumb = stickyBar.querySelector('.product__sticky-thumb');
      if (thumb) thumb.after(title);
      else stickyBar.prepend(title);
    }
    if (stickyBtn && !stickyBtn.querySelector('[data-current-price]')) {
      const label = stickyBtn.textContent.trim();
      const priceSpan = stickyBar.querySelector('.product__sticky-price');
      stickyBtn.textContent = '';
      stickyBtn.classList.add('product__sticky-btn');
      const labelEl = document.createElement('span');
      labelEl.textContent = label;
      const dot = document.createElement('span');
      dot.setAttribute('aria-hidden', 'true');
      dot.textContent = '·';
      const priceEl = document.createElement('span');
      priceEl.setAttribute('data-current-price', '');
      priceEl.textContent = priceSpan ? priceSpan.textContent.trim() : '';
      const compareEl = document.createElement('s');
      compareEl.hidden = true;
      stickyBtn.append(labelEl, dot, priceEl, compareEl);
      const compareWrap = root.querySelector('[data-compare-price-wrap]');
      const compareValue = root.querySelector('[data-compare-price]');
      const syncCompare = () => {
        const text = compareValue ? compareValue.textContent.trim() : '';
        const onSale = !!(compareWrap && !compareWrap.hidden && text);
        compareEl.hidden = !onSale;
        compareEl.textContent = onSale ? text : '';
      };
      syncCompare();
      if (compareWrap && 'MutationObserver' in window) {
        new MutationObserver(syncCompare).observe(compareWrap, {
          attributes: true, childList: true, subtree: true, characterData: true,
        });
      }
    }
  }

  /* ---------- AJAX add-to-cart ---------- */
  const form = document.getElementById('product-form');
  const errorEl = root.querySelector('[data-form-error]');
  if (form) {
    form.addEventListener('submit', async (e) => {
      /* Only intercept when a cart drawer exists; otherwise use native flow. */
      const drawer = document.getElementById('cart-drawer');
      if (!drawer || !window.SignatureCart) return;
      e.preventDefault();
      if (form.hasAttribute('data-add-pending')) return;
      form.setAttribute('data-add-pending', '');
      const wasDisabled = addBtn ? addBtn.disabled : false;
      if (errorEl) errorEl.hidden = true;
      if (addBtn) {
        addBtn.disabled = true;
        addBtn.setAttribute('aria-busy', 'true');
      }

      try {
        const outcome = await window.SignatureCart.requestAdd(form);
        if (outcome.status === 'accepted') {
          if (window.sigRefreshCart) {
            try {
              await window.sigRefreshCart();
            } catch (error) {
              /* The add was accepted even if the drawer refresh fails. */
            }
          }
          if (window.sigAnnounce) {
            window.sigAnnounce(addBtn && addBtn.getAttribute('data-label-added') || 'Added to cart');
          }
          window.sigOpenDialog(drawer, addBtn);
        } else {
          const attribute = outcome.status === 'rejected'
            ? 'data-add-error'
            : 'data-add-uncertain';
          const fallback = outcome.status === 'rejected'
            ? 'This item could not be added. Please try again.'
            : "We couldn't confirm whether this item was added. Check your cart before trying again.";
          const message = root.getAttribute(attribute) || fallback;
          if (errorEl) {
            errorEl.textContent = message;
            errorEl.hidden = false;
          }
          if (window.sigAnnounce) window.sigAnnounce(message);
        }
      } finally {
        form.removeAttribute('data-add-pending');
        if (addBtn) addBtn.removeAttribute('aria-busy');
        if (variantController) variantController.update(false);
        else if (addBtn) addBtn.disabled = wasDisabled;
      }
    });
  }
})();
